import React from 'react';
import { useEvents } from '../hooks/useEvents';
import EventOffersSlider from './partials/Event-offerslider';
import EventCard from './EventCard';
import './Events.css';

const Events = () => {
  const { events, loading } = useEvents();

  return (
    <main className="bg_white">
      <EventOffersSlider />

      <div
        className="petti_cream_rep"
        style={{
          backgroundImage: "url('/assets/img/bg/events-bg.webp')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          position: 'relative',
          backgroundColor: '#f5f5dc',
          minHeight: '60vh',
        }}
      >
        <div className="container margin_60_35" id="first_section">
          <div className="isotope-wrapper">
            <div className="title mb-3 text-center" style={{ paddingBottom: '20px' }}>
              <small data-cue="slideInUp" style={{ color: '#8b7355' }}>Celebrate Life</small>
              <h2 data-cue="slideInUp" data-delay="200" style={{ color: '#18373b' }}>Event Calendar</h2>
            </div>
            <div className="row justify-content-center home">
              {loading && (
                <div className="col-12 text-center">
                  <p className="event-status">Loading events...</p>
                </div>
              )}

              {!loading && events.length === 0 && (
                <div className="col-12 text-center">
                  <h3 className="event-status" style={{ fontSize: '30px', fontWeight: 700 }}>
                    No events yet!
                  </h3>
                </div>
              )}

              {!loading && events.map((event) => (
                <div className="col-lg-4 col-md-6 col-12 mb-4" key={event._id}>
                  <EventCard event={event} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Events;
